import React from 'react'
import { BCol, BRow } from '@prague-digi/ui-components'

import cons from '../../assets/identity/cons.svg'
import messages from '../../i18n'
import pros from '../../assets/identity/pros.svg'
import { intl, IntlInterface } from '../../hoc'

interface Props extends IntlInterface {}

export const OnlineVerification: React.FC<Props> = ({ translate, translateHTML }: Props) => (
  <>
    <BRow theme="mb-5">
      <BCol xs={2}>
        <img src={cons} alt="Nevýhody" />
      </BCol>
      <BCol>{translate(messages.identity.modal.cons)}</BCol>{' '}
    </BRow>

    <BRow>
      <BCol xs={2}>
        <img src={pros} alt="Výhody" />
      </BCol>
      <BCol>{translateHTML(messages.identity.modal.pros)}</BCol>
    </BRow>
  </>
)

export default intl(OnlineVerification)
